export const SECTION_ACCOUNT = 'account';
export const SECTION_DELIVERY = 'delivery';
export const SECTION_PAYMENT = 'payment';
